import withScript from './withScript'
import withGoogleMaps from './withGoogleMaps'

export default Component => withScript(withGoogleMaps(Component))
